<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  [closable]="false"
  [showHeader]="false" [(visible)]="show"
>
  <p>{{ 'revenue.transactions-grid.choose-template' | translate }}</p>
  <p-select
    optionLabel="Title"
    dataKey="ID"
    placeholder="{{ 'common.none' | translate | ucfirst }}"
    appendTo="body"
    [options]="htmlTemplates"
    [style]="{ width: '100%' }"
    [(ngModel)]="selectedHtmlTemplate"
  ></p-select>
  <ng-template pTemplate="footer">
    <wl-busy [show]="isCreatingEmail"></wl-busy>
    <button pButton type="button" class="btn btn-secondary" [disabled]="isCreatingEmail" (click)="cancelClicked.emit()">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
    <button pButton type="button" class="btn btn-primary" [disabled]="isCreatingEmail" (click)="createDraft()">
      {{ 'common.continue' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>
